
  var _styles = {
  "modal-base-close-btn": {
    "marginTop": "0.8rem"
  },
  "light-up-modal": {
    "display": "flex",
    "position": "relative",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "light-up-modal-main": {
    "display": "flex",
    "alignItems": "center",
    "position": "relative",
    "top": "-1.52rem"
  },
  "light-up-modal-title-wrap": {
    "marginTop": "5.84rem",
    "zIndex": 1
  },
  "light-up-modal-sub-title": {
    "fontWeight": "400",
    "height": "0.52rem",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "lineHeight": "0.52rem",
    "textAlign": "center"
  },
  "light-up-modal-title": {
    "color": "rgb(17,17,17)",
    "height": "1.26667rem",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.90667rem",
    "lineHeight": "1.26667rem",
    "textAlign": "center",
    "marginTop": "0.08rem"
  },
  "light-up-modal-buttons": {
    "width": "6.70667rem"
  },
  "light-up-modal-city-btn-wrap": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginTop": "1.21333rem"
  },
  "light-up-modal-city-btn": {
    "width": "100%",
    "height": "1.2rem"
  },
  "light-up-modal-tip": {
    "width": "2.10667rem",
    "height": "0.50667rem",
    "position": "absolute",
    "top": "-0.22667rem",
    "right": 0,
    "zIndex": 1
  },
  "light-up-modal-tip-text": {
    "fontWeight": "400",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.50667rem",
    "textAlign": "center"
  }
};



  module.exports = _styles;
  